<template>
  <Toast position="top-right" /><AppDialog />
  <router-view v-if="!auth.isLoggedIn" />
  <div v-else class="admin-shell">
    <aside class="desktop-sidebar">
      <div class="brand"><img class="brand-logo" src="/promart/promart-logo-stacked.svg?v=2" alt="CHAROENSANG PROMART" width="240" height="192" /></div>
      <Menu :model="menu" class="sidebar-menu"><template #item="{ item, props }"><router-link :to="item.path" v-bind="props.action" :class="{ 'nav-active': active(item.path) }"><i :class="item.icon" /><span>{{ item.label }}</span></router-link></template></Menu>
      <div class="sidebar-account"><i class="pi pi-user" /><span>{{ auth.user?.display_name || auth.user?.username }}</span><Button icon="pi pi-sign-out" text severity="secondary" aria-label="ออกจากระบบ" @click="logout" /></div>
    </aside>
    <Drawer v-model:visible="sidebarOpen" header="CHAROENSANG PROMART" class="mobile-drawer">
      <template #header><div class="flex items-center gap-3"><img class="drawer-brand-logo" src="/promart/promart-logo-light.svg?v=2" alt="CHAROENSANG PROMART" width="460" height="128" /></div></template>
      <Menu :model="menu"><template #item="{ item, props }"><router-link :to="item.path" v-bind="props.action" @click="sidebarOpen = false"><i :class="item.icon" /><span>{{ item.label }}</span></router-link></template></Menu>
      <Button label="ออกจากระบบ" icon="pi pi-sign-out" text @click="logout" />
    </Drawer>
    <div class="admin-main">
      <Toolbar class="app-toolbar">
        <template #start><Button class="mobile-menu-button" icon="pi pi-bars" text aria-label="เปิดเมนู" @click="sidebarOpen = true" /><span class="toolbar-title">{{ currentTitle }}</span></template>
        <template #end><Tag :value="roleLabel" severity="secondary" /><Button icon="pi pi-user" text rounded aria-label="เมนูผู้ใช้" @click="accountMenu.toggle($event)" /><Menu ref="accountMenu" :model="accountItems" popup /></template>
      </Toolbar>
      <Message v-if="previewMode" severity="warn" size="small">ตัวอย่าง · ไม่บันทึกข้อมูล</Message>
      <main class="admin-content"><router-view /></main>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import Toast from 'primevue/toast';
import AppDialog from './components/AppDialog.vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from './stores/auth';
import { previewMode } from './previewMode';
const auth = useAuthStore(), router = useRouter(), route = useRoute();
const sidebarOpen = ref(false), accountMenu = ref();
const baseMenu = [
 { path:'/', label:'ภาพรวม', icon:'pi pi-chart-bar', roles:['officer','admin','superadmin'] },
 { path:'/members', label:'ลูกค้า', icon:'pi pi-users', roles:['officer','admin','superadmin'] },
 { path:'/campaigns', label:'แคมเปญ', icon:'pi pi-megaphone', roles:['admin','superadmin'] },
 { path:'/coupons', label:'คูปอง', icon:'pi pi-ticket', roles:['admin','superadmin'] },
 { path:'/shops', label:'ร้านค้า', icon:'pi pi-shop', roles:['superadmin'], developerOnly:true },
 { path:'/sync', label:'สถานะ Sync', icon:'pi pi-sync', roles:['admin','superadmin'] },
];
const menu = computed(() => {
  const role = auth.user?.role;
  const items = baseMenu.filter(item => item.roles.includes(role) && (!item.developerOnly || auth.user?.is_internal));
  return role === 'superadmin'
    ? [...items, { path:'/users', label:'ผู้ใช้ระบบ', icon:'pi pi-user-edit' }]
    : items;
});
const roleLabel = computed(() => auth.user?.is_internal ? 'Developer' : ({ superadmin:'Superadmin', admin:'Admin', officer:'Officer' }[auth.user?.role] || 'ผู้ใช้ระบบ'));
const active = path => path === '/' ? route.path === '/' : route.path.startsWith(path);
const currentTitle = computed(() => menu.value.find(m => active(m.path))?.label || 'CHAROENSANG PROMART');
const accountItems = [{ label:'ออกจากระบบ', icon:'pi pi-sign-out', command: logout }];
function logout() { auth.logout(); sidebarOpen.value = false; router.push('/login'); }
</script>
